<template>
  <v-layout justify-center>
    <v-flex xs12>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex hidden-sm-and-down>
            <v-spacer></v-spacer>
          </v-flex>
          <v-btn slot="activator" @click="$router.push('/eventi/calendario')" class="btnDefault" small color="primary white--text" dark>
            <v-icon small class="mr-1">date_range</v-icon>Calendario
          </v-btn>

          <v-btn slot="activator" @click="manageClassifica($route.params.idEvento)" class="btnDefault" small color="primary white--text" dark>
            <v-icon small class="mr-1">people</v-icon
            >{{ isAdmin || (isResponsabile && dettagliEvento.AssociazioneId === userData.AssociazioneId) ? 'Gestisci iscritti' : 'Visualizza iscritti' }}
          </v-btn>

          <v-btn slot="activator" v-if="isAdmin" @click="dialogClassificaOpen()" style="text-xs-center" class="btnDefault" small color="accent white--text" dark>
            <v-icon small class="mr-1">import_export</v-icon>Gestione Classifica
          </v-btn>

          <v-btn slot="activator" @click="dialogExportOpen()" ma-auto class="btnDefault" small color="accent white--text" dark>
            <v-icon small class="mr-1">print</v-icon>Stampa Classifica
          </v-btn>

          <v-btn slot="activator" @click="loadClassificaEvento($route.params.idEvento)" class="btnDefault" small color="primary white--text" dark>
            <v-icon small class="mr-1">cached</v-icon>Aggiorna
          </v-btn>
        </v-layout>
      </v-container>

      <v-container fluid>
        <v-layout v-if="$route.params.idEvento" row class="text-xs-center">
          <v-flex xs12>
            <div class="text-xs-center">
              <h5 class="primary--text font-weight-bold text-uppercase pt-1">CLASSIFICA EVENTO</h5>
              <div>
                <small v-text="dettagliEvento.AssociazioneDenominazione" class="text-xs-left accent--text"></small> -
                <small v-text="dettagliEvento.SezioneDescrizione" class="text-xs-left accent--text"></small>
              </div>
              <h5 class="primary--text font-weight-bold text-uppercase pt-1">{{ dettagliEvento.TipoEventoDescrizione }} - {{ dettagliEvento.TitoloEvento }}</h5>
              id gara: {{ $route.params.idEvento }} - {{ Util.formattaData(dettagliEvento.DataEvento) }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="mt-4 mb-3">
          <v-flex xs12 md3 class="px-1 text-xs-right mt-4">
            <v-text-field v-model="filtraTesto" box label="Cerca" clearable hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 md2 class="px-1 text-xs-right mt-4">
            <v-autocomplete v-model="classeSelected" :items="classi" box clearable label="Classe" return-object hide-details></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 md2 class="px-1 text-xs-right mt-4">
            <v-autocomplete v-model="categoriaSelected" :items="categorie" item-text="Descrizione" box clearable label="Categoria" return-object hide-details></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout column>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="rankingFiltrate"
            :search="filtraTesto"
            :pagination.sync="pagination"
            :hide-headers="isMobile"
            :class="{ mobile: isMobile }"
            disable-initial-sort
            class="elevation-1 mt-3"
          >
            <template slot="items" slot-scope="props">
              <tr v-if="!isMobile" :style="{ color: getColorCategopria(props.item.categoriaCodice) }">
                <td class="text-xs-center">{{ props.item.Classe }}</td>
                <td class="text-xs-center">{{ props.item.Categoria }}</td>
                <td class="text-xs-right">{{ props.item.Posizione }}</td>
                <td class="text-xs-right">{{ props.item.NumeroTessera }}</td>
                <td bold class="text-xs-left font-weight-bold">{{ props.item.Denominazione }}</td>
                <td bold class="text-xs-left">{{ props.item.associazioneDenominazione }}</td>
                <td bold class="text-xs-left">{{ props.item.descrizioneSezione }}</td>
                <td bold class="text-xs-right">{{ props.item.Punteggio }}</td>
                <td bold class="text-xs-right">{{ props.item.Spot }}</td>
                <td bold class="text-xs-right">{{ props.item.SuperSpot }}</td>
                <td bold class="text-xs-right">{{ props.item.Perfect }}</td>

                <td bold class="text-xs-center">
                  <v-avatar v-if="props.item.isOpen" size="24" color="blue" small>
                    <span class="white--text xm">O</span>
                  </v-avatar>
                  <v-avatar v-else size="24" color="red" small>
                    <span class="white--text xm">U</span>
                  </v-avatar>
                </td>
              </tr>
              <tr v-else :active="props.selected" @click="props.selected = !props.selected">
                <td class="flex-td">
                  <ul class="flex-content" ma-10>
                    <li class="text-xs-center font-weight-bold flex-content" data-label="Arciere:  ">{{ props.item.Denominazione }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" data-label="Classe:  ">{{ props.item.Classe }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" data-label="Categoria:  ">{{ props.item.Categoria }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" data-label="Posizione:  ">{{ props.item.Posizione }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" data-label="N' Tessera:  ">{{ props.item.NumeroTessera }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" bold data-label="Sodalizio:  ">{{ props.item.associazioneDenominazione }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" bold data-label="Sezione:  ">{{ props.item.descrizioneSezione }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" bold data-label="Punteggio:  ">{{ props.item.Punteggio }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" bold data-label="Spot:  ">{{ props.item.Spot }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" bold data-label="SuperSpot:  ">{{ props.item.SuperSpot }}</li>
                    <li class="text-xs-center font-weight-bold flex-content" bold data-label="Perfect:  ">{{ props.item.Perfect }}</li>
                  </ul>
                </td>
              </tr>
            </template>
            <template slot="no-results">
              <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
            </template>
            <!-- PAGINAZIONE IN TABELLA  -->
            <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
          </v-data-table>
        </v-layout>
      </v-container>

      <v-dialog v-model="dialogExport" persistent max-width="700" style="margin: auto;">
        <v-card>
          <v-card-title class="display-1 font-weight-bold accent white--text">Stampa Classifica</v-card-title>
          <v-card-text v-if="isAdmin" class="headline">Scegli il formato della classifica</v-card-text>
          <v-card-text v-else class="headline">Verrà scaricata la classifica in formato PDF</v-card-text>
          <v-card-actions v-if="!isMobile">
            <v-spacer></v-spacer>
            <v-btn @click="dialogExport = false" ma-auto color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
            <v-btn @click="exportClassifica($route.params.idEvento, 0)" ma-0 color="accent white--text" dark> <v-icon small left>print</v-icon>Stampa pdf</v-btn>
            <v-btn v-if="isAdmin" @click="exportClassifica($route.params.idEvento, 1)" ma-0 color="accent white--text" dark> <v-icon small left>print</v-icon>esporta excel</v-btn>
          </v-card-actions>
          <v-card-actions v-else>
            <v-container align="center">
              <v-spacer></v-spacer>
              <v-btn @click="dialogExport = false" ma-auto color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="exportClassifica($route.params.idEvento, 0)" ma-0 color="accent white--text" dark> <v-icon small left>print</v-icon>Stampa pdf</v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="isAdmin" @click="exportClassifica($route.params.idEvento, 1)" ma-0 color="accent white--text" dark>
                <v-icon small left>print</v-icon>esporta excel</v-btn
              >
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogClassifica" style="margin: auto;" persistent max-width="1000">
        <v-card>
          <v-card-title class="display-1 font-weight-bold accent white--text">Gestione Classifica</v-card-title>
          <v-card-text class="headline">Importazione della classifica in formato Excel o eliminazione della stessa in caso di errori</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogClassifica = false" color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>

            <v-btn slot="activator" :disabled="isLoading" @click="eliminaClassifica($route.params.idEvento)" color="red white--text" class="btnDefault" dark>
              <v-icon small left>delete</v-icon>Elimina Classifica
            </v-btn>

            <v-btn slot="activator" :disabled="isLoading" @click="pickFile" color="accent white--text" class="btnDefault" dark>
              <v-icon small left>import_export</v-icon>Importa Classifica
            </v-btn>

            <v-btn slot="activator" :disabled="isLoading || dettagliEvento.Classificati == 0" @click="addNotificaClassifica" color="purple white--text" class="btnDefault">
              <v-icon small left>send</v-icon>crea notifica Classifica
            </v-btn>

            <input ref="fileClassifica" @change="onFilePicked" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;" />
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Errori durante il caricamento della classifica</span>
          </v-card-title>
          <v-card-text>
            <span v-html="errorMessage"></span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="
                errorDialog = false;
                loadClassificaEvento($route.params.idEvento);
              "
              color="green darken-1"
              flat="flat"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isLoading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Attendere caricamento classifica
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import FileEntity from '../generale/FileEntity';

  export default {
    components: {},
    data() {
      return {
        Util,
        ruoliUtente: Security.ruolo,
        elencoFunzioni: Security.enFunzione,
        ruoli: Security.ruolo,
        formModes: Util.enFormMode,
        classeSelected: null,
        categoriaSelected: null,
        filtraTesto: '',
        isMobile: false,
        isLoading: false,
        errorMessage: '',
        dialogExport: false,
        dialogClassifica: false,
        errorDialog: false,
        selected: [],
        prenotazioneDialog: false,
        partecipazioneObj: null,
        classificaObj: new FileEntity(),
        classi: ['Master Maschile', 'Master Femminile', 'Lupetto Maschile', 'Lupetto Femminile', 'Prime Freccie'],
        headers: [
          { text: 'Classe', sortable: true, value: 'classe', align: 'center' },
          { text: 'Categoria', sortable: true, value: 'categoria', align: 'center' },
          { text: 'Posizione', sortable: true, value: 'Posizione', align: 'right' },
          { text: 'N° Tessera', sortable: true, value: 'NumeroTessera', align: 'right' },
          { text: 'Arciere', sortable: true, value: 'Denominazione' },
          { text: 'Sodalizio', sortable: true, value: 'Denominazione' },
          { text: 'Sezione', sortable: true, value: 'codiceSezione' },
          { text: 'Punteggio', sortable: true, value: 'Punteggio' },
          { text: 'Spot', sortable: true, value: 'Spot', align: 'center' },
          { text: 'Super', sortable: true, value: 'Super', align: 'center' },
          { text: 'Perfect', sortable: true, value: 'Perfect', align: 'center' },
          { text: 'Stato', sortable: true, value: '', align: 'center' },
        ],
        pagination: {
          rowsPerPage: -1,
        },
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('eventiModule', ['getClassificaEventoView', 'getEventoView']),
      ...mapGetters('sharedModule', ['getCategorieEvento', 'getCategorieEventoEuropeo']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),
      categorie() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice != 'FO' && p.Codice != 'DI';
        });
      },
      categorieEuropeo() {
        return this.getCategorieEventoEuropeo;
      },
      dettagliEvento() {
        return this.getEventoView;
      },
      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },
      classifica() {
        return this.getClassificaEventoView;
      },
      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },
      isResponsabile() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE;
        } else {
          return false;
        }
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      rankingFiltrate() {
        let classificaList = null;
        if (this.classifica) {
          classificaList = this.classifica.filter((i) => {
            if (this.categoriaSelected == null) {
              return true;
            } else {
              return i.isAttivo == 1 && i.categoriaCodice == this.categoriaSelected.Codice;
            }
          });
          classificaList = classificaList.filter((i) => {
            if (this.classeSelected == null) {
              return true;
            } else {
              return i.Classe == this.classeSelected;
            }
          });

          return classificaList;
        } else {
          return this.classifica;
        }
      },
    },
    watch: {
      fileClassifica() {
        this.classificaObj = new FileEntity(this.fileClassifica);
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.pagination.rowsPerPage = 7;
            this.isMobile = true;
            break;
          case 'md':
            this.pagination.rowsPerPage = 10;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 22;
            this.isMobile = false;
            break;
        }
      },
      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      vm.loadTipologie().then();
      vm.refreshList();

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.pagination.rowsPerPage = 7;
          break;
        case 'md':
          this.pagination.rowsPerPage = 10;
          break;
        case 'lg':
          this.pagination.rowsPerPage = 15;
          break;
        case 'xl':
          this.pagination.rowsPerPage = 22;
          break;
      }

      bus.$on('rinnovoUploaded', function (value) {
        if (value) {
          vm.isLoading = false;
          vm.dialogClassifica = false;
          vm.errorDialog = false;
          vm.refreshList();
        }
      });

      bus.$on('classificaUploaded', function (value) {
        if (value) {
          vm.isLoading = false;
          vm.dialogClassifica = false;
          vm.errorDialog = false;
          vm.refreshList();
        }
      });

      bus.$on('closeDialogRefresh', function (value) {
        if (value) {
          vm.isLoading = false;
          vm.dialogClassifica = false;
          vm.errorDialog = false;
          vm.refreshList();
        }
      });

      bus.$on('erroreClassifica', function (value) {
        if (value != '') {
          vm.isLoading = false;
          vm.errorMessage = value;
          vm.errorDialog = true;
        }
      });
    },
    methods: {
      ...mapActions('eventiModule', ['loadEventoView', 'loadClassificaEvento', 'updateClassifica', 'exportClassificaPDF', 'exportClassificaXLS', 'removeClassifica']),
      ...mapActions('sharedModule', ['loadTipologie']),
      ...mapActions('notificheModule', ['pushNotificaClassifica']),
      refreshList() {
        const vm = this;
        if (this.$route.params.idEvento) {
          vm.loadEventoView({idEvento: this.$route.params.idEvento});
          vm.loadClassificaEvento(this.$route.params.idEvento);
        }
      },

      manageClassifica(idEvento) {
        this.$router.push({ name: 'eventi/calendario/partecipazioni', params: { idEvento: idEvento } });
      },

      addNotificaClassifica() {
        const vm = this;
        vm.pushNotificaClassifica(this.$route.params.idEvento);
      },

      dialogClassificaOpen() {
        const vm = this;
        vm.dialogClassifica = true;
      },

      dialogExportOpen() {
        const vm = this;
        vm.dialogExport = true;
      },

      manageIscritti(idEvento) {
        this.$router.push({ name: 'eventi/calendario/partecipazioni', params: { idEvento: idEvento } });
      },

      getColorCategopria(codiceCategoria) {
        if (this.categorie) {
          const cat = this.categorie.filter((a) => {
            return a.Codice == codiceCategoria;
          });
          if (cat.length == 1) {
            return cat[0].Tag.split('|')[1];
          }
        }
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      exportClassifica(idEvento, x) {
        const vm = this;
        if (x == 0) {
          vm.exportClassificaPDF(idEvento);
          vm.dialogExport = false;
        }
        if (x == 1) {
          vm.exportClassificaXLS(idEvento);
          vm.dialogExport = false;
        }
      },

      importClassifica() {
        const vm = this;
        // vm.exportClassificaXLS();
        vm.dialogClassifica = false;
      },

      eliminaClassifica(idEvento) {
        const vm = this;
        vm.removeClassifica(idEvento);
        vm.dialogClassifica = false;
      },

      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },
      canModifyEvento(idEvento, idAssociazione) {
        let retVal = false;
        if (idEvento) {
          if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.userid) {
            retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      pickFile() {
        this.$refs.fileClassifica.click();
      },
      onFilePicked(e) {
        const files = e.target.files;
        if (files[0] !== undefined) {
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener('load', () => {
            this.classificaObj = new FileEntity();
            this.classificaObj.blobFile = fr.result.replace('data:' + files[0].type + ';base64,', '');
            let uploadData = new FormData();
            uploadData.append('id', this.$route.params.idEvento);
            uploadData.append('classifica', files[0], files[0].name);
            this.dialogClassifica = false;
            this.isLoading = true;
            this.updateClassifica({ id: this.$route.params.idEvento, uploadData: uploadData }).then((i) => {});
            this.$refs.fileClassifica.value = '';
          });
        } else {
          this.classificaObj = new FileEntity();
        }
      },
    },
  };
</script>
